module["exports"] = [
  "#{Address.city} #{suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/team/name.js
 ** module id = 1013
 ** module chunks = 0
 **/